export default __webpack_public_path__ + "static/medium-image-sportplus-2-5d674389df556739324097a5950f3174.png";